import { render } from "./MarbelAssistantChat.vue?vue&type=template&id=064119e3&scoped=true"
import script from "./MarbelAssistantChat.vue?vue&type=script&lang=js"
export * from "./MarbelAssistantChat.vue?vue&type=script&lang=js"

import "./MarbelAssistantChat.vue?vue&type=style&index=0&id=064119e3&scoped=true&lang=css"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-064119e3"]])

export default __exports__